import { useEffect } from "react";
import { createPortal } from "react-dom";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const navBtn = "absolute top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/10 border border-white/20 hover:bg-white/20 transition-colors";

export const Lightbox = ({ images, carousel, alt, onClose }) => {
  const { current, next, prev, swipeHandlers } = carousel;

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = overflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose, next, prev]);

  const stop = (fn) => (e) => {
    e.stopPropagation();
    fn();
  };

  return createPortal(
    <div
      className="lightbox-in fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center touch-pan-y select-none"
      onClick={onClose}
      {...swipeHandlers}
      data-testid="lightbox"
    >
      <img
        src={images[current]}
        alt={`${alt} ${current + 1}`}
        className="max-w-[94vw] max-h-[88vh] object-contain rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-image"
      />
      <button onClick={stop(onClose)} className="absolute top-4 right-4 p-2 rounded-full bg-white/10 border border-white/20 hover:bg-white/20 transition-colors" aria-label="Fermer" data-testid="lightbox-close-button">
        <X size={24} />
      </button>
      <button onClick={stop(prev)} className={`${navBtn} left-3 sm:left-6`} aria-label="Précédent" data-testid="lightbox-prev-button">
        <ChevronLeft size={26} />
      </button>
      <button onClick={stop(next)} className={`${navBtn} right-3 sm:right-6`} aria-label="Suivant" data-testid="lightbox-next-button">
        <ChevronRight size={26} />
      </button>
      <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/70 text-sm" data-testid="lightbox-counter">
        {current + 1} / {images.length}
      </p>
    </div>,
    document.body
  );
};
